import { useGetRequest } from "@ch/api/useGetRequest";
import { type Chat, ChatControllerService } from "@ch/generated";
import { updateAppChatState } from "@ch/redux-store/chat/actions";
import { useAppSelector } from "@ch/redux-store/hooks/useAppSelector";
import { useRef } from "react";
import { useDispatch } from "react-redux";

const useGetUnreadMessages = () => {
  const dispatch = useDispatch();
  const ref = useRef<boolean>(true);
  const user = useAppSelector((state) => state.user?.currentUser);

  // fetch unread messages once
  useGetRequest({
    service: ChatControllerService.chatControllerGetUnreadMessages,
    tag: "chatControllerGetUnreadMessages",
    payload: { id: user?.id ?? "", senderType: "user" },
    enabled: ref.current,
    onSuccess: (data: Chat[]) => {
      dispatch(updateAppChatState({ unreadMessages: data }));
      ref.current = false;
    },
  });
};

export default useGetUnreadMessages;
